export const DEFAULT_TABLE_PARAMS = {
  current: 1,
  pageSize: 25,
}

export const DEFAULT_TABLE_PARAMS_WITH_SEARCH = {
  ...DEFAULT_TABLE_PARAMS,
  debouncedValue: '',
}
